var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.name)?_c('span',{staticClass:"camera-platform"},[_vm._v(" Платформа: "+_vm._s(_vm.name)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }